import { io, Socket } from "socket.io-client";

const SOCKET_URL = process.env.SOCKET_URL;

const token = localStorage.getItem("token");

export const socket: Socket = io(SOCKET_URL, {
  transports: ["websocket"],
  // auth: { token },
});
socket.on("connect", () => {
  console.info("Connected to the socket server");
});
socket.on("new_notification", (notification) => {
  console.info("New Notification:", notification);
});
socket.on("notification_updated", (notification) => {
  console.info("Notification Updated:", notification);
});
socket.on("disconnect", () => {
  console.info("Disconnected from the socket server");
});
export const markAsRead = (notificationId: number) => {
  socket.emit("mark_as_read", { notification_id: notificationId });
};
